module.exports = __webpack_public_path__ + "assets/poland.43330bee64d6808f17edb534d7e223cd.svg?";